import React, { useState, useRef, useEffect } from "react";
import { Image, Descriptions } from "antd";
import factoryImg from "../../assets/screen-factory-img.png";
import "./index.css";
import Analysisapi from "@/api/analysis";

export default () => {
  const [comprehensiveInfo, setComprehensiveInfo] = useState({});
  const [stationInfo, setStationInfo] = useState({});

  useEffect(() => {
    Analysisapi.getComprehensiveInfo({}).then((res) => {
      setComprehensiveInfo(res.data || {});
    });
    Analysisapi.getStationInfo({ stationId: 61 }).then((res) => {
      setStationInfo(res.data || {});
    });
  }, []);

  //获取值显示
  const getValue = (value) => {
    return value || "--";
  };

  return (
    <div
      className="compositeEval"
      style={{
        padding: 60,
        height: "100%",
        position: "relative",
        backgroundColor: "#071729",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: 30,
          display: "flex",
          alignItems: "center",
        }}
      >
        <p style={{ margin: 0, color: "#fff", fontSize: "24px" }}>综合评分</p>
        <p
          style={{
            color: "#5CF374",
            fontSize: 40,
            margin: 0,
            paddingLeft: 10,
            fontWeight: 600,
          }}
        >
          {comprehensiveInfo.score || 0}
        </p>
      </div>
      <h2 className="maintitle">{stationInfo.name}</h2>
      <div className="content-row">
        <p className="content-desc">
          {stationInfo.introduce}
        </p>
        <div className="img-content">
          <Image width={600} src={factoryImg} />
        </div>
        <div style={{ flex: 1 }}></div>
      </div>
      <div className="desc-content">
        <div className="desc-box">
          <Descriptions column={1}>
            <Descriptions.Item label="设备健康">
              {getValue(comprehensiveInfo.deviceHealthy)} %
            </Descriptions.Item>
            <Descriptions.Item label="水质达标率">
              {getValue(comprehensiveInfo.waterQualityPercent)} %
            </Descriptions.Item>
            <Descriptions.Item label="吨水电耗">
              {getValue(comprehensiveInfo.waterDnb)} Kwh
            </Descriptions.Item>
          </Descriptions>
        </div>
        <div className="desc-box">
          <Descriptions column={1}>
            <Descriptions.Item label="设计产水指标">
              {getValue(comprehensiveInfo.designQuota)} m³/d
            </Descriptions.Item>
            <Descriptions.Item label="今日产水量">
              {getValue(comprehensiveInfo.todayProdWater)} m³
            </Descriptions.Item>
            <Descriptions.Item label="今日电耗">
              {getValue(comprehensiveInfo.todayDnb)} Kwh
            </Descriptions.Item>
          </Descriptions>
        </div>
        <div className="desc-box">
          <Descriptions column={1}>
            <Descriptions.Item label="工单数量">
              {getValue(comprehensiveInfo.workOrderNum)}
            </Descriptions.Item>
            <Descriptions.Item label="缺陷单数量">
              {getValue(comprehensiveInfo.defectOrderNum)}
            </Descriptions.Item>
            <Descriptions.Item label="告警数量">
              {getValue(comprehensiveInfo.alamNum)}
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    </div>
  );
};
